import { Injectable } from '@angular/core';
import { Result } from '../../shared/result';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LocalstorageService } from 'src/app/global/localstorage.service';
import { BehaviorSubject } from 'rxjs';
import { CommonModel } from 'src/app/shared/common-model';
// import { AuthGuard } from 'src/app/authentication/guards/auth-guard.service'

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  data: any;
  public Token: string;
  obj = new CommonModel;
  lan: string;

  constructor(private http: HttpClient) {
    this.obj.lan = LocalstorageService.getLanguage("language");
    this.lan = LocalstorageService.getLanguage("language");
  //   this.data = JSON.parse(localStorage.getItem('currentUser'));
  //   this.Token = LocalstorageService.getLocal('Token');
  // // alert(this.Token)
  //   if(this.data != null)
  //     this.Token = this.data.token;
  }

  // public InitHeader() {
  //   let headers;
  //   if(this.Token) {
  //     headers = { 'Authorization': 'Bearer ' + this.Token, 
  //     'Content-Type': 'application/json'  };
  //   }
  //   return headers;
  // }

  public GetStatisticCount() {
    // let headers;
    // headers = this.InitHeader();
    //return this.http.get<Result>(`${environment.apiUrl}/GetStatisticsData/GetStatisticsData?lan=` + this.lan);
    return this.http.post<Result>(`${environment.apiUrl}/GetStatisticsData/GetStatisticsData`, this.obj);
  }

  public GetAnnouncement() {
    // let headers;
    // headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/GetStatisticsData/GetAnnouncementData`, this.obj);
    // return this.http.get<Result>(`${environment.apiUrl}/GetStatisticsData/GetAnnouncementData?lan=` + this.lan);
  }
  public GetVisitorCount() {
    // let headers;
    // headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/Login/GetVisitorCount`, this.obj);
    // return this.http.get<Result>(`${environment.apiUrl}/Login/GetVisitorCount?lan=` + this.lan);
  }

  public GetCMDSpeaks() {
    debugger;
    // let headers;
    // headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/GetStatisticsData/GetCMDSpeaks`, this.obj);
    // return this.http.get<Result>(`${environment.apiUrl}/GetStatisticsData/GetCMDSpeaks?lan=` + this.lan);
  }

  public SetVisitorCount() {
    // let headers;
    // headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/GetStatisticsData/SetVisitorCount`, this.obj);
  }

  public GetAllRoutesDashboard() {
    // let headers;
    // headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/GetStatisticsData/GetAllRoutesDashboard_Web`, this.obj);
  }

  public GetAlertMessage() {
    // let headers;
    // headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/GetStatisticsData/GetAlertMessage`, this.obj);
    // return this.http.get<Result>(`${environment.apiUrl}/GetStatisticsData/GetAlertMessage?lan=` + this.lan);
  }

  public GetStationCodePdf() {
    // let headers;
    // headers = this.InitHeader();
    return this.http.post<Result>(`${environment.apiUrl}/GetStatisticsData/StopCodeExportToPDF`, this.obj);
  }
}
